import React from 'react'
import { Chart } from 'react-google-charts';
import './support-chart.scss'


export default ({ supportChartData }) => (
    <div style={{marginTop:15}}>
        <Chart
          chartType="PieChart"
          data={supportChartData}
          options={{
                    pieHole: 0.4,
                    'sliceVisibilityThreshold': 0.0009,
                    chartArea: { 
                        left: 20, 
                        top:40,
                        width: '85%', 
                        height: '85%'
                    },
                    legend: {
                        position: 'right',
                        alignment: 'center',
                        textStyle: {color: '#363d4d', fontSize: 15}                        
                    },
                    fontName : 'Muli',
                    fontSize : 15
                    ,
                    tooltip: {
                        textStyle: {color: '#000', fontSize: 16}
                    }
                    }}
          graph_id="PieChartSupport"
          width="95%"
          height="95%"
          legend_toggle
        />
    </div>
)